import React, { useCallback, useContext, useState } from 'react';
import classNames from 'classnames';
import RfiContext from 'router/subrouters/DataRoom/providers/Rfi/Rfi.context';
import RfiAnalyticsInstance from './components/RfiAnalyticsInstance';
import RfiAnalyticsUploader from './components/RfiAnalyticsUploader';
import { useTranslation } from 'react-i18next';

import './RfiAnalyticsTable.styles.scss';
import './RfiAnalyticsTable.styles.responsive.scss';

type RfiAnalyticsTableProps = {
  className?: string;
};

const RfiAnalyticsTable: React.FC<RfiAnalyticsTableProps> = (props) => {
  const { className } = props;

  const [selectedRfi, setSelectedRfi] = useState<string>();

  const { rfis } = useContext(RfiContext);

  const classes = classNames('rfi-analytics-table', className);

  const { t } = useTranslation();

  const updateSelectedRfi = useCallback(
    (id: string) => {
      if (id === selectedRfi) setSelectedRfi('');
      else setSelectedRfi(id);
    },
    [selectedRfi],
  );

  return (
    <div className={classes}>
      <div>
        <div className="header grid">
          <p>{t('request')}</p>
          <p>{t('status')}</p>
          <p className="categories">{t('categories')}</p>
          <p className="uploaded-files">{t('uploadedFiles')}</p>
          <p>{t('dueDate')}</p>
          <p>{t('views')}</p>
          <p />
        </div>

        {rfis.map((rfi) => (
          <div key={rfi._id}>
            <RfiAnalyticsInstance rfi={rfi} onClick={updateSelectedRfi} />
            <RfiAnalyticsUploader rfi={rfi} isOpen={rfi._id === selectedRfi} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default RfiAnalyticsTable;
